import React from 'react';

export const ConfirmedOfferLogo = (props: { className?: string }) => {
  return (
    <svg
      width="153"
      height="153"
      viewBox="0 0 153 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="152.518" height="152.518" rx="7.1773" fill="#F2F2F2" />
      <path
        d="M15.7103 34.7C15.2501 34.7 14.9944 34.4443 14.9944 33.984V17.3129C14.9944 16.8527 15.2501 16.597 15.7103 16.597H17.9604C18.4207 16.597 18.7019 16.8527 18.7019 17.3129V33.984C18.7019 34.4443 18.4207 34.7 17.9604 34.7H15.7103ZM25.8301 23.1427H25.8813C26.6483 22.3245 28.0546 21.6597 29.7166 21.6597C32.3247 21.6597 34.2424 23.7308 34.2424 26.569V33.984C34.2424 34.4443 33.9867 34.7 33.5264 34.7H31.3786C30.9184 34.7 30.6627 34.4443 30.6627 33.984V27.6429C30.6627 25.9297 29.87 24.8814 28.566 24.8814C27.5944 24.8814 26.4949 25.4439 25.9324 26.1087V33.984C25.9324 34.4443 25.6767 34.7 25.1909 34.7H23.0687C22.6084 34.7 22.3527 34.4443 22.3527 33.984V22.6825C22.3527 22.2222 22.6084 21.9409 23.0687 21.9409H25.0886C25.5489 21.9409 25.8301 22.2222 25.8301 22.6825V23.1427ZM36.5652 25.853C36.5652 23.245 38.4317 21.6597 41.3722 21.6597C43.7245 21.6597 45.7701 22.5802 46.7673 24.1143C47.0229 24.4979 46.8951 24.8047 46.3837 25.0348L44.8751 25.7252C44.5683 25.853 44.2103 25.7507 43.8524 25.4439C43.341 24.9837 42.5739 24.6257 41.6279 24.6257C40.8608 24.6257 40.0937 24.9581 40.0937 25.5718C40.0937 25.9809 40.2983 26.4411 41.7046 26.7224L43.3154 27.0292C45.6934 27.4895 47.0485 28.9469 47.0485 30.7879C47.0485 33.3959 45.0797 34.9812 41.9858 34.9812C39.5823 34.9812 37.4601 34.0607 36.4629 32.5266C36.2072 32.143 36.335 31.8362 36.8464 31.6061L38.355 30.9157C38.6618 30.7879 39.0198 30.8901 39.3778 31.197C39.9147 31.6828 40.7329 32.0152 41.7301 32.0152C42.6251 32.0152 43.52 31.6828 43.52 31.0691C43.52 30.66 43.3154 30.1998 41.9091 29.9185L40.2983 29.6117C37.9203 29.1514 36.5652 27.694 36.5652 25.853ZM53.7532 29.7907C53.7532 31.0691 54.2902 31.8106 55.1851 31.8106C55.4664 31.8106 55.7988 31.7595 56.2079 31.6317C56.7448 31.4782 56.9238 31.5805 57.1539 32.0919L57.742 33.2936C58.0233 33.8306 57.9721 34.163 57.4608 34.3931C56.5403 34.8022 55.7988 34.9812 54.8016 34.9812C52.0657 34.9812 50.1735 33.1658 50.1735 30.0464V24.9581H48.1536C47.6933 24.9581 47.4376 24.7024 47.4376 24.2422V22.6569C47.4376 22.1711 47.6933 21.9409 48.1536 21.9409H50.1735V19.6653C50.1735 19.3329 50.4548 19.0516 50.9918 18.8471L52.6282 18.1823C53.3441 17.901 53.7532 18.08 53.7532 18.6937V21.9409H57.0005C57.4863 21.9409 57.7164 22.1711 57.7164 22.6569V24.2422C57.7164 24.7024 57.4863 24.9581 57.0005 24.9581H53.7532V29.7907ZM71.7513 30.2254C71.7513 31.1458 72.0581 31.7084 72.544 31.7084H72.5951C73.0809 31.7084 73.311 31.9129 73.311 32.322V33.4471C73.311 34.2908 72.6974 34.8022 71.3678 34.8022C70.2427 34.8022 69.5012 34.342 68.9643 33.0891C67.8137 34.2908 66.2539 34.9812 64.7454 34.9812C61.4981 34.9812 58.89 32.0152 58.89 28.3332C58.89 24.6257 61.4981 21.6597 64.7454 21.6597C66.075 21.6597 67.4046 22.2478 68.1972 23.1427H68.2739V22.6825C68.2739 22.1966 68.5552 21.9409 69.0154 21.9409H71.0098C71.47 21.9409 71.7513 22.2222 71.7513 22.6825V30.2254ZM68.2739 26.1343C67.6091 25.3416 66.5352 24.8814 65.5124 24.8814C63.697 24.8814 62.4697 26.3133 62.4697 28.3332C62.4697 30.3532 63.697 31.7595 65.5124 31.7595C66.5608 31.7595 67.6091 31.2993 68.2739 30.5066V26.1343ZM78.9161 23.1427H78.9672C79.7343 22.3245 81.1406 21.6597 82.8026 21.6597C85.4106 21.6597 87.3283 23.7308 87.3283 26.569V33.984C87.3283 34.4443 87.0726 34.7 86.6124 34.7H84.4646C84.0043 34.7 83.7486 34.4443 83.7486 33.984V27.6429C83.7486 25.9297 82.956 24.8814 81.652 24.8814C80.6803 24.8814 79.5809 25.4439 79.0183 26.1087V33.984C79.0183 34.4443 78.7626 34.7 78.2768 34.7H76.1546C75.6944 34.7 75.4387 34.4443 75.4387 33.984V22.6825C75.4387 22.2222 75.6944 21.9409 76.1546 21.9409H78.1746C78.6348 21.9409 78.9161 22.2222 78.9161 22.6825V23.1427ZM95.0035 29.7907C95.0035 31.0691 95.5404 31.8106 96.4353 31.8106C96.7166 31.8106 97.049 31.7595 97.4581 31.6317C97.995 31.4782 98.174 31.5805 98.4041 32.0919L98.9922 33.2936C99.2735 33.8306 99.2224 34.163 98.711 34.3931C97.7905 34.8022 97.049 34.9812 96.0518 34.9812C93.3159 34.9812 91.4238 33.1658 91.4238 30.0464V24.9581H89.4038C88.9436 24.9581 88.6879 24.7024 88.6879 24.2422V22.6569C88.6879 22.1711 88.9436 21.9409 89.4038 21.9409H91.4238V19.6653C91.4238 19.3329 91.705 19.0516 92.242 18.8471L93.8784 18.1823C94.5943 17.901 95.0035 18.08 95.0035 18.6937V21.9409H98.2507C98.7365 21.9409 98.9667 22.1711 98.9667 22.6569V24.2422C98.9667 24.7024 98.7365 24.9581 98.2507 24.9581H95.0035V29.7907ZM15.7359 61.7C15.2501 61.7 14.9944 61.4443 14.9944 60.984V44.3129C14.9944 43.8527 15.2501 43.597 15.7359 43.597H26.3727C26.8329 43.597 27.0886 43.8527 27.0886 44.3129V46.3073C27.0886 46.7676 26.8329 47.0233 26.3727 47.0233H18.7019V51.6001H25.9636C26.4494 51.6001 26.6795 51.8303 26.6795 52.3161V54.2338C26.6795 54.694 26.4238 54.9497 25.9636 54.9497H18.7019V60.984C18.7019 61.4443 18.4207 61.7 17.9604 61.7H15.7359ZM29.7408 57.6345V44.0061C29.7408 43.5459 29.9965 43.2902 30.4567 43.2902H32.579C33.0648 43.2902 33.3205 43.5459 33.3205 44.0061V57.1998C33.3205 58.0947 33.6784 58.7084 34.241 58.7084H34.3177C34.8035 58.7084 35.0336 58.9129 35.0336 59.322V60.984C35.0336 61.5977 34.5478 61.9301 33.6017 61.9301C31.1471 61.9301 29.7408 60.3704 29.7408 57.6345ZM42.5561 48.6597C46.2637 48.6597 48.8973 51.37 48.8973 55.2054V55.7168C48.8973 56.177 48.6416 56.4583 48.1814 56.4583H39.9225C40.3061 57.9413 41.4822 58.8362 43.1187 58.8362C43.9624 58.8362 44.8318 58.5805 45.3687 58.197C45.7778 57.9157 45.9824 57.8134 46.3404 57.9669L47.9257 58.6828C48.4115 58.8873 48.5393 59.3476 48.2325 59.7056C46.775 61.2653 45.1898 61.9812 43.1187 61.9812C39.181 61.9812 36.3173 59.1942 36.3173 55.3332C36.3173 51.4979 39.002 48.6597 42.5561 48.6597ZM42.7096 51.7024C41.2521 51.7024 40.3061 52.5206 39.9737 53.9014H45.3687C44.9596 52.3161 43.988 51.7024 42.7096 51.7024ZM53.7047 49.6825L56.0059 52.853L58.2816 49.6825C58.7418 49.0432 58.9208 48.9409 59.3299 48.9409H61.4777C62.0658 48.9409 62.3982 49.3756 62.0914 49.7847L57.898 55.2821L61.9891 60.8562C62.2703 61.2397 61.9635 61.7 61.3754 61.7H58.9719C58.5628 61.7 58.3327 61.521 57.9236 60.9584L55.6224 57.7367L53.27 60.9584C52.7842 61.5977 52.6308 61.7 52.2217 61.7H50.0739C49.4858 61.7 49.1534 61.2397 49.4602 60.8562L53.6535 55.2821L49.6648 49.7847C49.3835 49.4012 49.6903 48.9409 50.2784 48.9409H52.7075C53.1166 48.9409 53.2444 49.0432 53.7047 49.6825ZM63.4923 45.1056C63.4923 43.955 64.4383 43.0089 65.5378 43.0089C66.7651 43.0089 67.7368 43.955 67.7368 45.1056C67.7368 46.2818 66.7396 47.2278 65.5378 47.2278C64.4383 47.2278 63.4923 46.2562 63.4923 45.1056ZM63.8247 57.6345V49.6569C63.8247 49.1966 64.0804 48.9409 64.5406 48.9409H66.6628C67.1487 48.9409 67.4044 49.1966 67.4044 49.6569V57.1998C67.4044 58.0947 67.7623 58.7084 68.3248 58.7084H68.4015C68.8874 58.7084 69.1175 58.9129 69.1175 59.322V60.984C69.1175 61.5977 68.6317 61.9301 67.6856 61.9301C65.2054 61.9301 63.8247 60.3704 63.8247 57.6345ZM71.9353 56.0236C71.4495 56.0236 71.2193 55.7935 71.2193 55.3077V53.7224C71.2193 53.2366 71.475 53.0064 71.9353 53.0064H78.1486C78.6088 53.0064 78.8645 53.2621 78.8645 53.7224V55.3077C78.8645 55.7679 78.6344 56.0236 78.1486 56.0236H71.9353ZM82.5379 60.984V44.3129C82.5379 43.8271 82.7936 43.597 83.2538 43.597H85.5039C85.9642 43.597 86.2454 43.8527 86.2454 44.3129V58.2737H93.8906C94.3508 58.2737 94.6065 58.5294 94.6065 59.0152V60.984C94.6065 61.4443 94.3508 61.7 93.8906 61.7H83.2538C82.7936 61.7 82.5379 61.4443 82.5379 60.984ZM95.9203 55.3332C95.9203 51.5234 98.8608 48.6597 102.722 48.6597C106.583 48.6597 109.498 51.5234 109.498 55.3332C109.498 59.0919 106.557 61.9812 102.722 61.9812C98.8608 61.9812 95.9203 59.0919 95.9203 55.3332ZM105.918 55.3332C105.918 53.3644 104.563 51.8814 102.722 51.8814C100.906 51.8814 99.5 53.3644 99.5 55.3332C99.5 57.2765 100.906 58.7595 102.722 58.7595C104.537 58.7595 105.918 57.3021 105.918 55.3332ZM124.088 57.2254C124.088 58.1458 124.395 58.7084 124.881 58.7084H124.932C125.418 58.7084 125.648 58.9129 125.648 59.322V60.4471C125.648 61.2908 125.034 61.8022 123.705 61.8022C122.58 61.8022 121.838 61.342 121.301 60.0891C120.151 61.2908 118.591 61.9812 117.082 61.9812C113.835 61.9812 111.227 59.0152 111.227 55.3332C111.227 51.6257 113.835 48.6597 117.082 48.6597C118.412 48.6597 119.741 49.2478 120.534 50.1427H120.611V49.6825C120.611 49.1966 120.892 48.9409 121.352 48.9409H123.347C123.807 48.9409 124.088 49.2222 124.088 49.6825V57.2254ZM120.611 53.1343C119.946 52.3416 118.872 51.8814 117.849 51.8814C116.034 51.8814 114.807 53.3133 114.807 55.3332C114.807 57.3532 116.034 58.7595 117.849 58.7595C118.898 58.7595 119.946 58.2993 120.611 57.5066V53.1343ZM131.253 50.1427H131.304C132.071 49.3245 133.477 48.6597 135.139 48.6597C137.747 48.6597 139.665 50.7308 139.665 53.569V60.984C139.665 61.4443 139.409 61.7 138.949 61.7H136.801C136.341 61.7 136.085 61.4443 136.085 60.984V54.6429C136.085 52.9297 135.293 51.8814 133.989 51.8814C133.017 51.8814 131.918 52.4439 131.355 53.1087V60.984C131.355 61.4443 131.099 61.7 130.614 61.7H128.491C128.031 61.7 127.776 61.4443 127.776 60.984V49.6825C127.776 49.2222 128.031 48.9409 128.491 48.9409H130.511C130.972 48.9409 131.253 49.2222 131.253 49.6825V50.1427Z"
        fill="#111C22"
      />
      <path
        d="M105.1 41.6957C102.49 41.6957 101.427 39.1793 101.234 39.0649C102.007 42.6336 100.525 45.432 99.6869 46.3852C100.331 45.9277 102.152 44.637 103.347 44.2937C106.419 43.4113 109.009 43.3787 109.589 43.3787C110.308 43.3787 111.19 43.297 111.19 42.4963C111.19 41.8558 110.298 41.6957 109.589 41.6957H105.1Z"
        fill="#FB5950"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.468 38.0032L100.722 39.1739C101.454 42.5531 100.041 45.1871 99.2935 46.0382L99.9889 46.8097C100.311 46.5813 100.915 46.1529 101.584 45.7398C102.266 45.3192 102.967 44.9447 103.491 44.7944C106.496 43.9312 109.031 43.8997 109.588 43.8997C109.948 43.8997 110.437 43.8828 110.848 43.7234C111.062 43.6403 111.284 43.5078 111.452 43.2921C111.626 43.0694 111.712 42.7973 111.712 42.4945C111.712 41.8573 111.242 41.52 110.843 41.3661C110.443 41.2121 109.968 41.171 109.588 41.171H105.1C103.983 41.171 103.192 40.6384 102.638 40.0597C102.359 39.7693 102.146 39.4722 101.987 39.2328C101.933 39.1516 101.899 39.099 101.867 39.0486C101.841 39.009 101.817 38.9706 101.784 38.9208C101.756 38.8792 101.725 38.833 101.694 38.7923C101.693 38.7915 101.692 38.7906 101.691 38.7896C101.672 38.7646 101.604 38.6751 101.499 38.6131L100.468 38.0032ZM101.971 40.8732C102.65 41.5514 103.67 42.2167 105.1 42.2167H109.588C109.917 42.2167 110.243 42.2556 110.467 42.3419C110.68 42.424 110.668 42.485 110.667 42.4936C110.667 42.494 110.667 42.4943 110.667 42.4945C110.667 42.592 110.642 42.6304 110.628 42.6482C110.609 42.6729 110.566 42.711 110.469 42.7485C110.259 42.8301 109.948 42.854 109.588 42.854C108.985 42.854 106.34 42.8878 103.202 43.7893C102.603 43.9614 101.897 44.3319 101.263 44.7115C101.682 43.6816 102 42.3715 101.971 40.8732ZM100.865 39.4307C100.856 39.419 100.857 39.4218 100.867 39.4326C100.866 39.4319 100.866 39.4313 100.865 39.4307Z"
        fill="#FB5950"
      />
      <path
        d="M67.5498 87.2683C61.2198 80.9382 60.3921 71.5028 65.7012 66.1937L88.6244 89.1169C83.3153 94.426 73.8799 93.5984 67.5498 87.2683Z"
        fill="#2A4656"
      />
      <path
        d="M91.3216 41.9394C91.3216 45.1159 93.8967 47.691 97.0732 47.691C100.25 47.691 102.825 45.1159 102.825 41.9394C102.825 38.7628 100.25 36.1877 97.0732 36.1877C93.8967 36.1877 91.3216 38.7628 91.3216 41.9394Z"
        fill="#EBA4A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.4473 49.4938C95.7717 46.4237 96.1479 44.6791 97.0056 43.5355L91.7418 39.5872C89.2422 42.9195 89.1504 46.952 90.0211 50.9081C90.8871 54.8434 92.8281 59.2889 95.1905 64.0502C96.8807 67.4567 98.5936 70.9718 99.6997 74.5677C100.801 78.1467 101.222 81.5697 100.519 84.7858C99.7274 88.4094 97.7076 91.3839 95.2404 93.9596C93.4571 95.8213 91.6595 97.278 89.9527 98.6613C89.1977 99.2731 88.4604 99.8706 87.75 100.482L92.0437 105.468C92.511 105.066 93.0917 104.595 93.746 104.064C95.5467 102.603 97.9051 100.69 99.9922 98.5113C102.942 95.4314 105.806 91.4144 106.948 86.1902C107.978 81.4736 107.28 76.8295 105.989 72.6331C104.703 68.4537 102.752 64.4851 101.085 61.1255C98.7473 56.4144 97.1276 52.5847 96.4473 49.4938Z"
        fill="#EBA4A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.7912 124.65C52.3627 125.473 57.9744 123.438 61.7233 119.235L72.1071 107.594L78.3503 113.163L67.9666 124.804C62.3432 131.108 53.9255 134.161 45.5684 132.926L39.9318 132.093L41.1546 123.817L46.7912 124.65Z"
        fill="#B57272"
      />
      <path
        d="M43.9784 102.974L74.2233 117.015C83.7252 121.426 94.794 115.439 96.3016 105.072C97.6746 95.6308 90.3539 87.1685 80.8137 87.1685H47.4684C43.9276 87.1685 40.7779 89.4178 39.6289 92.767C38.2518 96.7811 40.1293 101.187 43.9784 102.974Z"
        fill="#1B2D37"
      />
      <path
        d="M49.5867 87.9765C48.2095 80.1351 39.9966 73.2002 36.0623 70.713L47.7508 104.355C48.9367 102.163 50.964 95.8179 49.5867 87.9765Z"
        fill="#1B2D37"
      />
      <path
        d="M53.6334 96.1994C53.0996 89.6369 37.2067 79.4974 27.5125 74.4667C30.603 82.7295 38.1237 99.9727 43.4831 102.844C50.1823 106.432 54.3008 104.403 53.6334 96.1994Z"
        fill="#1B2D37"
      />
      <path
        d="M68.8474 105.481C59.9567 106.527 52.0381 101.33 51.1609 93.8737L83.3571 90.0859C84.2344 97.5427 77.7382 104.436 68.8474 105.481Z"
        fill="#3A6278"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.2247 109.141C71.5075 106.848 73.5955 105.218 75.8883 105.501L88.4829 107.055C95.091 107.87 101.104 111.277 105.2 116.527L123.119 139.498L116.522 144.644L98.6032 121.673C95.8731 118.173 91.8641 115.901 87.4588 115.358L74.8642 113.804C72.5713 113.521 70.9419 111.433 71.2247 109.141Z"
        fill="#EBA4A4"
      />
      <path
        d="M105.18 130.394L111.961 125.184L123.935 139.699L116.778 145.276L105.18 130.394Z"
        fill="white"
      />
      <path
        d="M45.5711 124.443L43.7477 132.797L25.2357 129.424L27.1096 120.546L45.5711 124.443Z"
        fill="white"
      />
      <path
        d="M105.18 130.394L111.961 125.184L123.935 139.699L116.778 145.276L105.18 130.394Z"
        fill="white"
      />
      <path
        d="M45.5711 124.443L43.7477 132.797L25.2357 129.424L27.1096 120.546L45.5711 124.443Z"
        fill="white"
      />
      <path
        d="M113.129 126.597L114.434 128.165L107.616 133.515L106.302 131.888L113.129 126.597Z"
        fill="#699FE3"
      />
      <path
        d="M41.9416 132.47L39.9324 132.114L41.6941 123.628L43.7477 124.025L41.9416 132.47Z"
        fill="#699FE3"
      />
      <path
        d="M113.129 126.597L114.434 128.165L107.616 133.515L106.302 131.888L113.129 126.597Z"
        fill="#699FE3"
      />
      <path
        d="M41.9416 132.47L39.9324 132.114L41.6941 123.628L43.7477 124.025L41.9416 132.47Z"
        fill="#699FE3"
      />
      <path
        d="M122.647 140.094C121.252 140.288 119.971 139.296 119.808 137.897C119.643 136.482 120.688 135.213 122.11 135.103L130.914 134.424L130.916 138.949L122.647 140.094Z"
        fill="#FB5950"
      />
      <path
        d="M25.9662 128.29C26.9078 127.243 28.5264 127.174 29.553 128.138C30.5919 129.114 30.6114 130.758 29.596 131.758L23.3047 137.955L20.3855 134.497L25.9662 128.29Z"
        fill="#FB5950"
      />
      <path
        d="M122.647 140.094C121.252 140.288 119.971 139.296 119.808 137.897C119.643 136.482 120.688 135.213 122.11 135.103L130.914 134.424L130.916 138.949L122.647 140.094Z"
        fill="#FB5950"
      />
      <path
        d="M25.9662 128.29C26.9078 127.243 28.5264 127.174 29.553 128.138C30.5919 129.114 30.6114 130.758 29.596 131.758L23.3047 137.955L20.3855 134.497L25.9662 128.29Z"
        fill="#FB5950"
      />
      <path
        d="M116.422 144.783L135.611 130.511C137.465 129.132 140.085 129.517 141.464 131.371L118.919 148.14L116.422 144.783Z"
        fill="#FB5950"
      />
      <path
        d="M27.7014 120.693L22.2385 143.975C21.7108 146.224 19.4597 147.619 17.2106 147.092L23.629 119.737L27.7014 120.693Z"
        fill="#FB5950"
      />
      <path
        d="M116.422 144.783L135.611 130.511C137.465 129.132 140.085 129.517 141.464 131.371L118.919 148.14L116.422 144.783Z"
        fill="#FB5950"
      />
      <path
        d="M27.7014 120.693L22.2385 143.975C21.7108 146.224 19.4597 147.619 17.2106 147.092L23.629 119.737L27.7014 120.693Z"
        fill="#FB5950"
      />
      <path
        d="M126.96 144.896C126.405 144.15 125.788 143.356 125.622 143.133L128.139 141.26L126.96 144.896Z"
        fill="#699FE3"
      />
      <path
        d="M19.5734 127.402C20.4784 127.615 21.4617 127.824 21.7332 127.888L21.0166 130.942L19.5734 127.402Z"
        fill="#699FE3"
      />
      <path
        d="M126.96 144.896C126.405 144.15 125.788 143.356 125.622 143.133L128.139 141.26L126.96 144.896Z"
        fill="#699FE3"
      />
      <path
        d="M19.5734 127.402C20.4784 127.615 21.4617 127.824 21.7332 127.888L21.0166 130.942L19.5734 127.402Z"
        fill="#699FE3"
      />
      <path
        d="M129.694 143.17C129.139 142.424 128.284 141.506 128.117 141.282L130.634 139.41L129.694 143.17Z"
        fill="#699FE3"
      />
      <path
        d="M18.5958 130.484C19.5007 130.697 20.7468 130.847 21.0182 130.91L20.3016 133.965L18.5958 130.484Z"
        fill="#699FE3"
      />
      <path
        d="M129.694 143.17C129.139 142.424 128.284 141.506 128.117 141.282L130.634 139.41L129.694 143.17Z"
        fill="#699FE3"
      />
      <path
        d="M18.5958 130.484C19.5007 130.697 20.7468 130.847 21.0182 130.91L20.3016 133.965L18.5958 130.484Z"
        fill="#699FE3"
      />
      <path
        d="M132.29 141.473C131.735 140.727 130.765 139.659 130.598 139.435L133.116 137.563L132.29 141.473Z"
        fill="#699FE3"
      />
      <path
        d="M17.7071 133.452C18.6121 133.664 20.0423 133.855 20.3138 133.919L19.5972 136.973L17.7071 133.452Z"
        fill="#699FE3"
      />
      <path
        d="M132.29 141.473C131.735 140.727 130.765 139.659 130.598 139.435L133.116 137.563L132.29 141.473Z"
        fill="#699FE3"
      />
      <path
        d="M17.7071 133.452C18.6121 133.664 20.0423 133.855 20.3138 133.919L19.5972 136.973L17.7071 133.452Z"
        fill="#699FE3"
      />
      <path
        d="M134.739 139.594C134.182 138.849 133.243 137.819 133.076 137.595L135.59 135.718L134.739 139.594Z"
        fill="#699FE3"
      />
      <path
        d="M17.0465 136.471C17.9518 136.681 19.3343 136.863 19.606 136.926L18.895 139.982L17.0465 136.471Z"
        fill="#699FE3"
      />
      <path
        d="M136.882 137.622L135.438 135.869L141.468 131.369C142.254 132.323 142.083 133.74 141.093 134.479L136.882 137.622Z"
        fill="#699FE3"
      />
      <path
        d="M16.6789 139.36L18.912 139.768L17.2049 147.096C15.9893 146.874 15.2064 145.68 15.4868 144.477L16.6789 139.36Z"
        fill="#699FE3"
      />
      <path
        d="M126.973 144.855L125.631 143.134L118.919 148.128C119.665 149.084 121.038 149.27 122.011 148.546L126.973 144.855Z"
        fill="#699FE3"
      />
      <path
        d="M19.5886 127.442L21.7235 127.892L23.6337 119.747C22.4469 119.497 21.2776 120.24 21.0007 121.421L19.5886 127.442Z"
        fill="#699FE3"
      />
      <path
        d="M126.973 144.855L125.631 143.134L118.919 148.128C119.665 149.084 121.038 149.27 122.011 148.546L126.973 144.855Z"
        fill="#699FE3"
      />
      <path
        d="M19.5886 127.442L21.7235 127.892L23.6337 119.747C22.4469 119.497 21.2776 120.24 21.0007 121.421L19.5886 127.442Z"
        fill="#699FE3"
      />
      <path
        d="M126.134 134.795L126.82 134.742L127.023 137.383L126.337 137.436L126.134 134.795Z"
        fill="black"
      />
      <path
        d="M26.7167 134.588L26.2259 135.072L24.3676 133.184L24.8583 132.701L26.7167 134.588Z"
        fill="black"
      />
      <path
        d="M126.134 134.795L126.82 134.742L127.023 137.383L126.337 137.436L126.134 134.795Z"
        fill="black"
      />
      <path
        d="M26.7167 134.588L26.2259 135.072L24.3676 133.184L24.8583 132.701L26.7167 134.588Z"
        fill="black"
      />
      <path
        d="M127.602 134.681L128.289 134.628L128.492 137.269L127.805 137.322L127.602 134.681Z"
        fill="black"
      />
      <path
        d="M25.6688 135.622L25.1781 136.105L23.3197 134.218L23.8105 133.735L25.6688 135.622Z"
        fill="black"
      />
      <path
        d="M127.602 134.681L128.289 134.628L128.492 137.269L127.805 137.322L127.602 134.681Z"
        fill="black"
      />
      <path
        d="M25.6688 135.622L25.1781 136.105L23.3197 134.218L23.8105 133.735L25.6688 135.622Z"
        fill="black"
      />
      <path
        d="M124.728 134.897L125.415 134.847L125.607 137.489L124.92 137.539L124.728 134.897Z"
        fill="black"
      />
      <path
        d="M27.7225 133.607L27.2296 134.088L25.3796 132.192L25.8725 131.711L27.7225 133.607Z"
        fill="black"
      />
      <path
        d="M124.728 134.897L125.415 134.847L125.607 137.489L124.92 137.539L124.728 134.897Z"
        fill="black"
      />
      <path
        d="M27.7225 133.607L27.2296 134.088L25.3796 132.192L25.8725 131.711L27.7225 133.607Z"
        fill="black"
      />
      <path
        d="M100.994 41.938C100.994 43.815 99.4724 45.3367 97.5953 45.3367C95.7183 45.3367 94.1967 43.815 94.1967 41.938C94.1967 40.061 95.7183 38.5393 97.5953 38.5393C99.4724 38.5393 100.994 40.061 100.994 41.938Z"
        fill="white"
      />
      <path
        d="M100.995 41.7774C100.995 43.2754 99.7809 44.4898 98.2829 44.4898C96.7848 44.4898 95.5704 43.2754 95.5704 41.7774C95.5704 40.2793 96.7848 39.0649 98.2829 39.0649C99.7809 39.0649 100.995 40.2793 100.995 41.7774Z"
        fill="#0C2340"
      />
      <path
        opacity="0.2"
        d="M15.0034 72.7498C-0.577989 72.7498 -13.2092 85.381 -13.2092 100.962L43.216 100.962C43.216 85.381 30.5848 72.7498 15.0034 72.7498Z"
        fill="#3A6278"
      />
      <path
        opacity="0.2"
        d="M160.343 53.5961C137.584 53.5961 119.134 72.0458 119.134 94.8047L201.551 94.8047C201.551 72.0458 183.102 53.5961 160.343 53.5961Z"
        fill="#3A6278"
      />
    </svg>
  );
};
